export default __webpack_public_path__ + "static/media/checklist.d768753c.png";